// storage.js - photographs taken on a phone: tag-outs, inspections, repair receipts.
//
// #6 AND #536 ARE FIXED HERE TOGETHER, AND THEY HAD TO BE.
//
// #6, open since Audit 1 as "two independent Supabase client instances exist":
// this file used to build its OWN connection with the production address and key
// WRITTEN INTO IT. So every tool photograph, inspection photograph and tag-out
// photograph uploaded to PRODUCTION even when the app was pointed at staging, and
// the screen looked correct the whole time - the split-brain shape CLAUDE.md warns
// about at #163 and #242. It is now the shared connection, so a photo lands in
// whichever database the rest of the app is talking to.
//
// WHY THAT COULD NOT WAIT FOR ANOTHER SESSION: #536 makes reads go through a
// signed address, and signing happens on the SHARED connection. Had the upload
// stayed pinned to production while the signing moved, a photo taken on staging
// would have been written to one database and looked for in the other - so
// closing the security hole alone would have broken every tool photo on staging.
// The two are one change.
//
// The other thing this file used to do was build a "/object/public/" address by
// hand from a hardcoded string, which is what made every stored photograph
// readable by anyone on the internet. It asks the storage service for a
// time-limited address instead. See src/lib/storedFile.js for the whole story.

import { supabase } from './supabase';
import { signedUrlFor, TOOL_BUCKET } from './storedFile';

export async function uploadPhoto(file, folder = 'tagouts') {
  try {
    const imageCompression = (await import('browser-image-compression')).default;
    const compressed = await imageCompression(file, {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    });

    const ext = file.name.split('.').pop() || 'jpg';
    const filename = `${folder}/${Date.now()}-${Math.random().toString(36).substring(2)}.${ext}`;

    const { data, error } = await supabase.storage
      .from(TOOL_BUCKET)
      .upload(filename, compressed, {
        cacheControl: '3600',
        upsert: false,
        contentType: file.type || 'image/jpeg',
      });

    if (error) throw error;
    return { path: data.path, error: null };
  } catch (err) {
    return { path: null, error: err.message };
  }
}

// NOW ASYNC - it has to be, because a time-limited address is fetched rather
// than assembled. Every caller was updated in the same commit; a caller that
// forgets to wait gets a Promise, which renders as nothing rather than as a
// broken image, so the failure is visible but harmless.
export async function getPhotoUrl(path) {
  return signedUrlFor(path, TOOL_BUCKET);
}
